export const isDev = () =>
    !process.env.NODE_ENV || process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'development';